import { __assign } from 'tslib';
import React__default, { memo, useState } from 'react';
import { Box, useTheme, Typography, Skeleton } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { animated, useSpring } from 'react-spring';
import KFavoriteButton from '../KButtons/KFavoriteButton/index.js';
import KSelectionButton from '../KButtons/KSelectionButton/index.js';
import StyledFormat, { classes } from './index.styled.js';

var FormatMeta = function (props) {
    switch (props.type) {
        case "extension":
            if (!props.value) {
                return null;
            }
            return (React__default.createElement(Typography, { component: "span", className: clsx(classes.metaExtenstion, classes.meta) }, props.value));
        case "resolution":
            return (React__default.createElement(Typography, { component: "span", className: clsx(classes.meta) },
                React__default.createElement("strong", null, props.value),
                React__default.createElement("small", null, props.unit)));
        case "size":
            return (React__default.createElement(Typography, { className: clsx(classes.meta) },
                React__default.createElement("strong", null, props.value.width),
                React__default.createElement("small", null, "x"),
                React__default.createElement("strong", null, props.value.height),
                React__default.createElement("small", null, props.unit)));
        default:
            return null;
    }
};
var defaultFormat = {
    title: "",
    description: "",
    metas: [],
    id: 0,
    active: false,
    href: ""
};
var AnimatedButton = animated(Box);
var FormatActions;
(function (FormatActions) {
    FormatActions["Select"] = "SELECT";
    FormatActions["Favorite"] = "FAVORITE";
})(FormatActions || (FormatActions = {}));
var Format = memo(function (_a) {
    var _b = _a.format, format = _b === void 0 ? defaultFormat : _b, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, _d = _a.onClickFavorite, onClickFavorite = _d === void 0 ? function () { } : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, className = _a.className, _f = _a.testId, testId = _f === void 0 ? "downloadFormat" : _f, _g = _a.actionsAvailable, actionsAvailable = _g === void 0 ? [FormatActions.Select] : _g, sx = _a.sx, KIcon = _a.KIcon;
    var _h = useState(false), hover = _h[0], setHover = _h[1];
    var theme = useTheme();
    var t = useTranslation("refront-components").t;
    var animatedPropsHover = useSpring({ translateY: hover ? "0%" : "100%" });
    var animatedButton = useSpring({
        marginTop: format.active ? -2 : 0,
        marginBottom: format.active ? 2 : 0,
        backgroundColor: format.active ? theme.palette.background.paper : theme.palette.grey[100],
        borderColor: format.active ? theme.palette.primary.main : theme.palette.text.primary,
        borderBottomWidth: format.active ? 3 : 1
    });
    var handleClick = function () {
        if (!loading && actionsAvailable.includes(FormatActions.Select)) {
            onClick();
        }
    };
    return (React__default.createElement(StyledFormat, { onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); }, onFocus: function () { return setHover(true); }, onBlur: function () { return setHover(false); }, className: clsx("Format-root"), sx: sx },
        React__default.createElement(AnimatedButton, { onClick: handleClick, title: loading ? undefined : format.title, "data-testid": testId, className: clsx("Format", classes.card, format.active && classes.active, loading && classes.loading, 
            // Integration or test purpose
            format.active && "Format-active", loading && "Format-loading", className), onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); }, onFocus: function () { return setHover(true); }, onBlur: function () { return setHover(false); }, style: animatedButton },
            React__default.createElement(Box, { className: classes.overflow },
                React__default.createElement(Box, { className: classes.content },
                    actionsAvailable.includes(FormatActions.Select) && (React__default.createElement(KSelectionButton, { visualHelper: true, active: format.active, visible: hover || format.active === true, title: "".concat(t("components.format.action.selectFormat"), " ").concat(format.title, " "), KIcon: KIcon })),
                    React__default.createElement(Typography, { className: classes.title, variant: "subtitle1", component: "div" }, loading ? (React__default.createElement(Skeleton, { "data-testid": "Format-skeleton", variant: "text", width: 50 })) : (format.title)),
                    React__default.createElement(Box, { className: classes.metas }, !loading && format.metas.map(function (meta) { return React__default.createElement(FormatMeta, __assign({ key: meta.type }, meta)); }))),
                !loading && !!format.description && (React__default.createElement(animated.div, { style: animatedPropsHover, className: classes.hover },
                    React__default.createElement(Typography, { className: classes.description, variant: "caption" }, format.description))))),
        actionsAvailable.includes(FormatActions.Favorite) && (React__default.createElement(KFavoriteButton, { onClick: onClickFavorite, active: format.favorite, visible: hover || format.favorite === true, onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); }, onFocus: function () { return setHover(true); }, onBlur: function () { return setHover(false); }, title: t("components.format.action.addToFavorite"), KIcon: KIcon }))));
});

export { FormatActions, Format as default };
//# sourceMappingURL=index.js.map
